/**
 * 本地开发（localhost）时把 nova-attachments 桶的预签名 URL 改走 vite 的 /s3-proxy，
 * 避开浏览器对 S3 的 CORS 限制；其他环境原样返回。附件上传与 Messages 图片上传共用。
 */
export function resolveS3UploadUrl(url: string): string {
  const isDevelopment = process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost'
  return isDevelopment && url.includes('nova-attachments.s3.amazonaws.com')
    ? url.replace('https://nova-attachments.s3.amazonaws.com', '/s3-proxy')
    : url
}
